import { Operation } from '../changelog/types';

export const NODE_WIDTH = 200;

// additional gutter used to pad the snippet node
export const EXPANDED_SNIPPET_NODE_GUTTER = 16;

// padding we use to offset the parent snippet node slightly
export const EXPANDED_SNIPPET_X_OFFSET = -8;
export const SNIPPET_Y_HOIST = -8;

export const XL_NODE_FIRST_ROW_HOIST = -8;

export const SNIPPET_NODE_HEIGHT = 44;
// used for risk calculation nodes
export const NODE_HEIGHT_XL = 48;
export const NODE_TEXT_MAX_WIDTH = 140;
export const CHILD_NODE_WIDTH = 184;
export const NODE_HEIGHT = 32;
export const COLUMN_SPACING = 64;
export const ROW_SPACING = 16;
export const CANVAS_HORIZONTAL_PADDING = 1 * COLUMN_SPACING;
export const CANVAS_VERTICAL_PADDING = 2 * ROW_SPACING;
export const CANVAS_PANNING_PADDING_HORIZONTAL = CANVAS_HORIZONTAL_PADDING;
export const CANVAS_PANNING_PADDING_VERTICAL = CANVAS_VERTICAL_PADDING;
export const COMPLEX_ISLAND_PADDING = NODE_WIDTH + (COLUMN_SPACING / 2);
export const COMPLEX_ISLAND_WIDTH = 504;
export const COMPLEX_ISLAND_DIFF_WIDTH = 1008;
// "in bounds" means that the size of the graph isn't larger than the canvas
// even with the Complex Island open
export const IN_BOUNDS_PADDING_WIDTH = (COLUMN_SPACING * 2);
// "out of bounds" means that the size of the graph is larger than the canvas
// even with the Complex Island open
export const OUT_OF_BOUNDS_PADDING_WIDTH = (COMPLEX_ISLAND_WIDTH + COLUMN_SPACING);
export const REQUIRED_SPACE_FOR_ISLAND_NODES = NODE_WIDTH;

export const SIMPLE_ISLAND_WIDTH = COLUMN_SPACING + REQUIRED_SPACE_FOR_ISLAND_NODES;

export const TOTAL_REQUIRED_SPACE_FOR_SIMPLE_NODES_X = (
  SIMPLE_ISLAND_WIDTH + CANVAS_PANNING_PADDING_HORIZONTAL
);

export const PEEKING_ISLAND_WIDTH = 40;

// additional padding added to the left child node so that it aligned with the
// right edge of all other nodes
export const LEFT_CHILD_PADDING = NODE_WIDTH - CHILD_NODE_WIDTH;

// Node Editor Drawer:
export const NODE_EDITOR_DRAWER_HEIGHT_COLLAPSED = 380;
export const NODE_EDITOR_DRAWER_BOTTOM_MARGIN = 32;
export const SPACE_FOR_NODE_EDITOR_DRAWER = NODE_EDITOR_DRAWER_HEIGHT_COLLAPSED
  + NODE_EDITOR_DRAWER_BOTTOM_MARGIN;

// Diff Styling:
export const DIFF_COLOR_BY_OPERATION: Record<Operation, string> = {
  [Operation.Add]: 'var(--cl-green-400)',
  [Operation.Modify]: 'var(--cl-yellow-400)',
  [Operation.Remove]: 'var(--cl-red-400)',
};
